export default {
  '***': {
    '***': [
      {
        "id": 10,
        "label": "Brand Image",
        "selected": 0,
        "collapse": 0,
        "parent": 0,
        "children": [
          25,
          30,
          50
        ],
        "tooltip": "This will be checked automatically when any item in this section is checked."
      },
      {
        "id": 25,
        "label": "Customer Service",
        "selected": 0,
        "collapse": 0,
        "parent": 10,
        "children": [],
        "tooltip": "Refers to a primary focus on customer service"
      },
      {
        "id": 30,
        "label": "Co-Brand",
        "selected": 0,
        "collapse": 0,
        "parent": 10,
        "children": [],
        "tooltip": "Single ad advertising for more than one brand ('Seamless + Taco Bell' or 'Marriott Chase credit card')"
      },

      {
        "id": 50,
        "label": "Sponsorship",
        "selected": 0,
        "collapse": 0,
        "parent": 10,
        "children": [],
        "tooltip": "Sponsorship of an event, sport or project (such as a food bank)"
      },

      {
        "id": 100,
        "label": "Creative Type",
        "selected": 0,
        "collapse": 0,
        "parent": 0,
        "children": [
          110,
          120,
          130,
          140
        ],
        "tooltip": "This will be checked automatically when any item in this section is checked."
      },
      {
        "id": 110,
        "label": "Narrative",
        "selected": 0,
        "collapse": 0,
        "parent": 100,
        "children": [],
        "tooltip": "Ad follows a story trajectory, even if short"
      },
      {
        "id": 120,
        "label": "Vignette/Montage",
        "selected": 0,
        "collapse": 0,
        "parent": 100,
        "children": [],
        "tooltip": "Ad does not have a story, but rather many different scenes cut together"
      },
      {
        "id": 130,
        "label": "Animated",
        "selected": 0,
        "collapse": 0,
        "parent": 100,
        "children": [],
        "tooltip": "At least half of ad is cartoon/animation and not filmed"
      },
      {
        "id": 140,
        "label": "Graphics/Product Images Only",
        "selected": 0,
        "collapse": 0,
        "parent": 100,
        "children": [],
        "tooltip": "Ad is a computer generated ad usually focusing on a product with few or no actual filmed scenes/beauty shots"
      },
      {
        "id": 1,
        "label": "Creative Style",
        "selected": 0,
        "collapse": 0,
        "parent": 0,
        "children": [
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9
        ],
        "tooltip": "This will be checked automatically when any item in this section is checked."
      },
      {
        "id": 2,
        "label": "Humorous",
        "selected": 0,
        "collapse": 0,
        "parent": 1,
        "children": [],
        "tooltip": "The intent of the ad is to make you laugh"
      },
      {
        "id": 3,
        "label": "Emotional",
        "selected": 0,
        "collapse": 0,
        "parent": 1,
        "children": [],
        "tooltip": "The intent of the ad is to elicit sad or heartwarming emotion"
      },
      {
        "id": 4,
        "label": "Spokesperson",
        "selected": 0,
        "collapse": 0,
        "parent": 1,
        "children": [],
        "tooltip": "Includes both celebrity and non-celebrity spokespeople"
      },
      {
        "id": 5,
        "label": "Celebrity (for brand NOT content)",
        "selected": 0,
        "collapse": 0,
        "parent": 1,
        "children": [],
        "tooltip": "Includes any celebrity inclusion, whether or not that person is a spokesperson"
      },
      {
        "id": 6,
        "label": "Music (jingle)",
        "selected": 0,
        "collapse": 0,
        "parent": 1,
        "children": [],
        "tooltip": "Refers to a consistent jingle associated with a brand, not just background music"
      },
      {
        "id": 7,
        "label": "Music (lyrics/song)",
        "selected": 0,
        "collapse": 0,
        "parent": 1,
        "children": [],
        "tooltip": "Refers to an identifiable song - either lyrics or instrumental"
      },
      {
        "id": 8,
        "label": "Branding in Intro (First 5 seconds)",
        "selected": 0,
        "collapse": 0,
        "parent": 1,
        "children": [],
        "tooltip": "The advertising brand is shown or spoken in the first 5 seconds"
      },
      {
        "id": 9,
        "label": "Voice Over Narration",
        "selected": 0,
        "collapse": 0,
        "parent": 1,
        "children": [],
        "tooltip": "An off-screen narrator is featured"
      },
      // {
      //   "id": 200,
      //   "label": "Platform Type",
      //   "selected": 0,
      //   "collapse": 0,
      //   "parent": 0,
      //   "children": [
      //     210,
      //     220,
      //     230
      //   ],
      //   "tooltip": "This will be checked automatically when any item in this section is checked."
      // },
      // {
      //   "id": 210,
      //   "label": "Subscription Video on Demand (SVOD)",
      //   "selected": 0,
      //   "collapse": 0,
      //   "parent": 200,
      //   "children": [],
      //   "tooltip": ""
      // },
      // {
      //   "id": 220,
      //   "label": " Virtual Multichannel Video (DMVPD/MVPD)",
      //   "selected": 0,
      //   "collapse": 0,
      //   "parent": 200,
      //   "children": [],
      //   "tooltip": ""
      // },
      // {
      //   "id": 230,
      //   "label": "Ad-Supported Video-On-Demand (AVOD)",
      //   "selected": 0,
      //   "collapse": 0,
      //   "parent": 200,
      //   "children": [],
      //   "tooltip": ""
      // },
      {
        "id": 250,
        "label": "Ad Type",
        "selected": 0,
        "collapse": 0,
        "parent": 0,
        "children": [
          260,
          270,
          280,
          290,
          300
        ],
        "tooltip": "This will be checked automatically when any item in this section is checked."
      },
      {
        "id": 260,
        "label": "Streaming single content",
        "selected": 0,
        "collapse": 0,
        "parent": 250,
        "children": [],
        "tooltip": ""
      },
      {
        "id": 270,
        "label": "Streaming multishow content",
        "selected": 0,
        "collapse": 0,
        "parent": 250,
        "children": [],
        "tooltip": ""
      },
      {
        "id": 280,
        "label": "Streaming brand",
        "selected": 0,
        "collapse": 0,
        "parent": 250,
        "children": [],
        "tooltip": ""
      },
      {
        "id": 290,
        "label": "Streaming multi brand",
        "selected": 0,
        "collapse": 0,
        "parent": 250,
        "children": [],
        "tooltip": ""
      },
      {
        "id": 300,
        "label": "Live TV",
        "selected": 0,
        "collapse": 0,
        "parent": 250,
        "children": [],
        "tooltip": ""
      },
      {
        "id": 340,
        "label": "Offers",
        "selected": 0,
        "collapse": 0,
        "parent": 0,
        "children": [
          360,
          370,
          380,
          381,
          385,
          387,
          388,
          389
        ],
        "tooltip": "This will be checked automatically when any item in this section is checked."
      },
      {
        "id": 360,
        "label": "Free trial",
        "selected": 0,
        "collapse": 0,
        "parent": 340,
        "children": [],
        "tooltip": ""
      },
      {
        "id": 370,
        "label": "Bundle pricing",
        "selected": 0,
        "collapse": 0,
        "parent": 340,
        "children": [],
        "tooltip": ""
      },
      {
        "id": 380,
        "label": "Limited time discount",
        "selected": 0,
        "collapse": 0,
        "parent": 340,
        "children": [],
        "tooltip": ""
      },

      {
        "id": 381,
        "label": "Value/Low Price",
        "selected": 0,
        "collapse": 0,
        "parent": 340,
        "children": [],
        "tooltip": ""
      },


      {
        "id": 385,
        "label": "Price lock",
        "selected": 0,
        "collapse": 0,
        "parent": 340,
        "children": [],
        "tooltip": ""
      },
      {
        "id": 387,
        "label": "Other streaming apps included",
        "selected": 0,
        "collapse": 0,
        "parent": 340,
        "children": [],
        "tooltip": ""
      },
      {
        "id": 388,
        "label": "No contract",
        "selected": 0,
        "collapse": 0,
        "parent": 340,
        "children": [],
        "tooltip": ""
      },
      {
        "id": 389,
        "label": "No hidden fees",
        "selected": 0,
        "collapse": 0,
        "parent": 340,
        "children": [],
        "tooltip": ""
      },
      {
        "id": 390,
        "label": "Content",
        "selected": 0,
        "collapse": 0,
        "parent": 0,
        "children": [
          400,
          410,
          420,
          430,
          435,
          440,
          445,
          450,
          455
        ],
        "tooltip": "This will be checked automatically when any item in this section is checked."
      },
      {
        "id": 400,
        "label": "TV programs",
        "selected": 0,
        "collapse": 0,
        "parent": 390,
        "children": [],
        "tooltip": ""
      },
      {
        "id": 410,
        "label": "Movies",
        "selected": 0,
        "collapse": 0,
        "parent": 390,
        "children": [],
        "tooltip": ""
      },
      {
        "id": 420,
        "label": "Social post",
        "selected": 0,
        "collapse": 0,
        "parent": 390,
        "children": [],
        "tooltip": ""
      },
      {
        "id": 430,
        "label": "Originals/Specials",
        "selected": 0,
        "collapse": 0,
        "parent": 390,
        "children": [],
        "tooltip": ""
      },
      {
        "id": 435,
        "label": "Events (e.g. pride, holiday content, etc.)",
        "selected": 0,
        "collapse": 0,
        "parent": 390,
        "children": [],
        "tooltip": ""
      },
      {
        "id": 455,
        "label": "Live Sports",
        "selected": 0,
        "collapse": 0,
        "parent": 390,
        "children": [],
        "tooltip": "Includes promotion of live sports content (does not include fictional sports-themed movies/shows)"
      },

      {
        "id": 440,
        "label": "Mostly for kids",
        "selected": 0,
        "collapse": 0,
        "parent": 390,
        "children": [],
        "tooltip": ""
      },
      {
        "id": 445,
        "label": "New Releases",
        "selected": 0,
        "collapse": 0,
        "parent": 390,
        "children": [],
        "tooltip": ""
      },
      {
        "id": 450,
        "label": "Speaks to diversity & inclusivity",
        "selected": 0,
        "collapse": 0,
        "parent": 390,
        "children": [],
        "tooltip": ""
      }
    ]
  }
};


// WEBPACK FOOTER //
// ./src/app/configuration/DisneyHulu/config/components/selection/Search/tagHierarchy.js